/**
 * Форматирует время в секундах в строку для описания продукта
 */
export function formatDurationInfo(time) {
    const hh = Math.floor(time / 3600);
    const mm = Math.round(time / 60 - hh * 60);
    const hhText = hh ? `${hh} ${plural(hh, ['час', 'часа', 'часов'])}` : '';
    const mmText = `${mm} ${plural(mm, ['минута', 'минуты', 'минут'])}`;
    return hhText ? `${hhText} ${mmText}` : mmText;
}
/**
 * Форматирует время в секундах в строку для описания продукта
 */
export function formatDuration(time) {
    time |= 0;
    const hh = Math.floor(time / 3600);
    const mm = Math.floor(time / 60 - hh * 60);
    const ss = time % 60;
    let result = `${pad(mm)}:${pad(ss)}`;
    if (hh) {
        result = `${pad(hh)}:` + result;
    }
    return result;
}
/**
 * Форматирует указанную дату согласно указанной строке форматирования
 */
export function formatDate(date, format) {
    let result = '';
    let i = 0;
    let ch = '';
    while (i < format.length) {
        ch = format[i++];
        if (ch === '\\') {
            result += format[i++];
        }
        else if (ch === '%') {
            result += getDateFragment(date, format[i++] || '');
        }
        else {
            result += ch;
        }
    }
    return result;
}
function getDateFragment(date, token) {
    switch (token) {
        case 'Y':
            return String(date.getFullYear());
        case 'M':
            return pad(date.getMonth() + 1);
        case 'D':
            return pad(date.getDate());
        case 'h':
            return pad(date.getHours());
        case 'm':
            return pad(date.getMinutes());
        case 's':
            return pad(date.getSeconds());
        default:
            return token;
    }
}
/**
 * Возвращает слово из массива `words`, подходящее для указанного числа num
 */
export function plural(num, words) {
    const number = Math.abs(num) % 100;
    let ix = 0;
    if (number > 10 && number < 20) {
        ix = 2;
    }
    else {
        const lastDigit = number % 10;
        if (lastDigit === 1) {
            ix = 0;
        }
        else if (lastDigit > 1 && lastDigit < 5) {
            ix = 1;
        }
        else {
            ix = 2;
        }
    }
    return words[Math.min(ix, words.length - 1)];
}
function pad(value) {
    return value >= 0 && value < 10 ? `0${value}` : String(value);
}
